import React from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import classNames from 'classnames';
import { database } from '../app-database';

const mapState = (state) => {
    return {
        preguntas1: state.catalogos.catalogoPregunta1,
        preguntas2: state.catalogos.catalogoPregunta2
    };
}

const mapDispatch = (dispatch) => {
    return {
		llenarPreguntas: (cat1, cat2) =>{
			dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2});
		}
    }
}

const validate = values => {
  function checkMayus(str) {
			return str.toLowerCase() != str;
	   }
    const errors = {};

    if(!values.telefono_movil) {
		errors.telefono_movil = 'Campo requerido.';
	} else if (!values.lada_movil && values.telefono_movil) {
		errors.telefono_movil = 'Campo Lada requerido.'
	} else if (values.lada_movil && values.telefono_movil && ((values.lada_movil.length + values.telefono_movil.length) -1) != 10) {
		errors.telefono_movil = 'Tu número de teléfono con lada incluida debe ser de 10 dígitos.'
	}

	if(values.lada_fijo && !values.telefono_fijo) {
		errors.telefono_fijo = 'Campo requerido.'
	}
	if(!values.lada_fijo && values.telefono_fijo) {
		errors.telefono_fijo = 'Campo Lada fijo requerido.'
	} else if (values.lada_fijo && values.telefono_fijo && ((values.lada_fijo.length + values.telefono_fijo.length) -1) != 10) {
		errors.telefono_fijo = 'Tu número de teléfono con lada incluida debe ser de 10 dígitos.';
	}

	if(values.lada_fijo == "+" && values.telefono_fijo == ""){
		delete errors.telefono_fijo;
	} else if(values.lada_fijo == "+" && !values.telefono_fijo){
		delete errors.telefono_fijo;
	}

    if (!values.password) {
        errors.password = "Campo requerido.";
    } else {
		var a = 0;
        var regexpr2 = /([\w])\1{2,}/;
        //var regexprAlfaNumerico = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
        var NUMEROS = "0123456789";
	    var ABC = "abcdefghijklmnopqrstuvwxyz";
	    var regexpr= /\s+/;

		if (values.password.length > 0 && values.password.length <= 7) {
			errors.password = <span>Debe ser mínimo de 8 posiciones.</span>;
		} else if(regexpr.test(values.password)){
	    	errors.password = <span>No se admiten espacios en blanco.</span>;
        } else if(values.password.toLowerCase().includes('gnp')) {
            errors.password = <span>No debe contener la palabra GNP.</span>;
        } else if (!/^[a-z0-9]+$/i.test(values.password)) {
			errors.password = "No debe contener caracteres especiales.";
		} else if (isNaN(values.password) == false) {
			errors.password = "Debe incluir caracteres alfabéticos.";
		} else if (/[0-9]/.test(values.password) == false) {
			errors.password = "Debe contener al menos un carácter numérico.";
		} else if(checkMayus(values.password) == false) {
  		errors.password = "Debe incluir al menos una mayúscula"
  	}else if(regexpr2.test(values.password)) {
            errors.password = <span>No debe contener más de dos caracteres iguales de forma consecutiva (p.e. 222, eee).</span>;
        } else {
            for(var i=0; i < values.password.length; i++) {
            	var cadena = values.password.substr(i,3).toLowerCase();
        			if(cadena.length == 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
        			    errors.password = <span>No debe contener más de dos caracteres numéricos o alfabéticos de forma consecutiva (p.e. 123, abc).</span>;
        			    break;
        			}
				/*if (i>=2 && i<=values.password.length) {
					var cad=values.password.substr(a,3).toLowerCase();
					if (NUMEROS.indexOf(cad)>=0 || ABC.indexOf(cad)>=0) {
						errors.password = <span>No debe contener más de dos caracteres numéricos o alfabéticos de forma consecutiva (p.e. 123, abc).</span>;
						break;
					}
					a++;
				}*/
			}
        }
    }

    if (!values.confpassword) {
        errors.confpassword = "Campo requerido.";
    } else if(values.confpassword!=values.password) {
    	errors.confpassword = <span>Tus contraseñas no coinciden. Favor de verificar.</span>;
    }

    if (!values.pregunta1 || values.pregunta1 == 0) {
		errors.pregunta1 = "Campo requerido.";
    }

    if (!values.respuesta1) {
        errors.respuesta1 = "Campo requerido.";
    } else  if (values.respuesta1==values.respuesta2) {
        errors.respuesta1 = <span>Tus respuestas no deben ser iguales. Favor de verificar.</span>;
    }

    if (!values.pregunta2 || values.pregunta2 == 0) {
        errors.pregunta2 = "Campo requerido.";
    }

    if (!values.respuesta2) {
        errors.respuesta2 = "Campo requerido.";
    } else if(values.respuesta1==values.respuesta2) {
        errors.respuesta2 = <span>Tus respuestas no deben ser iguales. Favor de verificar.</span>;
    }

    return errors;
}

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ")? value : '';
	texto = texto.replace(/\s{2,}/g, ' ');
	//texto = texto.replace(/^\s*|\s*$/g,"");

	campos[tipo] = texto;
}
const hideErrors = {};
const telefono = tipo => (value, campos) => {
	let numero = (value != undefined)? value.replace('+','').replace(' ','') : '';
	let prefijo = (/lada/g.test(tipo)) ? '+' : '';
	//campos[tipo] = (numero == '' || isNaN(numero))? '' : prefijo + numero;

	if(numero != '' && isNaN(numero)) {
		let _temp = "";
		for(let i = 0; i < numero.length; i++) {
			if(!isNaN(numero.substr(i,1))) {
				_temp  +=  numero.substr(i,1);
			}
		}
		numero = _temp;
	}

	if(numero != "") {
		campos[tipo] = prefijo + numero;
	} else {
		campos[tipo] = "";
	}

}
const renderField = ({ input, label, type, cerrar, max, meta: { touched, error, warning } }) => {
	let errorClass = classNames({'error-wrap': true, 'hidden': hideErrors[input.name]});
	return (
		<div>
			<input {...input} type={type} maxLength={max} />
			{touched && (error &&
				<div className={errorClass}>
					<div className='msj-error'>
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	)
}

const campo = ({ input, label, type, param, max, fnToggle,clase, meta: { touched, error } }) => {
    return <div className={ param ? "input-wrap visible-input" : "input-wrap ver-input"}>
		<label htmlFor={input.name}>{label}</label>
		<span className="input-active">
			{ !param &&
				<div>
					<input {...input} type={type} maxLength={max} className={clase}/>
				</div>
			}
			{ param &&
				<div >
					<input {...input} type="text" maxLength={max} className={clase}/>
				</div>
			}
		</span>
		<button type="button" className="btn-ojo" onClick={fnToggle}></button>
		{ touched && error &&
		    <div className="error-wrap">
		        <div className="msj-error">
		            <p><span>{error}</span></p>
		        </div>
			</div>
		}
	</div>
}

const renderSelectField = ({ input, label, type, meta: { touched, error }, children }) => (
 <div className="input-wrap no-margin">
   <label>{label}</label>
   <span className="clearfix input-active">
     <select {...input} className="col-xs-1">
       {children}
     </select>
   </span>
     {touched && error &&
    	<div className="error-wrap">
	        <div className="msj-error">
	            <p><span>{error}</span></p>
	        </div>
		</div>
     }
 </div>
)


class SeguridadForm extends React.Component{

    handleChange = (sParam, e) => {
        this.setState({[sParam]: e.target.value});
        this.validate(sParam,e.target.value);
    }

    toggle = (sParam) => {
        this.setState({[sParam]: !this.state[sParam]});
    }

    handleSelect = (sParam, e) => {
        this.setState({[sParam]: e});
    }

    state = {
    	showPass:false,
    	showConfPass: false,
    	showResp1:false,
    	showResp2: false,
        password: "",
        confPassword: '',
        respuesta1: "",
        respuesta2: "",
        pregunta1: 0,
        pregunta2: 0,
        validate : {
            password: false,
            confPassword: false,
            respuesta1: false,
            respuesta2: false
        }
    }

    componentWillMount = () => {
		database.ref("preguntas").on("value", snapshot => {
            let data = snapshot.val();
			this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
        });
	}

    componentDidMount = () => {
    	$('.pass, .confpass').bind('copy paste',function(e) { e.preventDefault(); return false; });
    }

    focus = (e) => {
		hideErrors[e.target.name] = false;
	}

	cerrar = (e) => {
		hideErrors[e] = true;
		let value = document.querySelector('input[name='+e+']').value == ''? ' ' : '';
		this.props.change(e, value);
	}

    render() {
    	const { handleSubmit } = this.props;

        return 	<form onSubmit={handleSubmit}>
      	<div className='text-content'>
        <div className="datos-wrap row mt-34">
        	<div className="col-xs-12">
        		<div className="row">
        			<div className="col-md-6 col-xs-12">
        				<h5>
							<i><img src={require('../img/icon_cellphone.png')} alt='' /></i>Teléfono celular
							<span className='orange-tooltip'>
								<button type='button' className='btn btn-primary btn-lg' data-toggle='modal' data-target='#modal-teléfonos' >?</button>
							</span>
						</h5>
        			</div>
					<div className="col-md-6 col-xs-12">
        				<h5><i><img src={require('../img/icon_phone.png')} alt='' /></i>Teléfono fijo (Opcional)</h5>
        			</div>
				</div>
			</div>
			<div className="col-xs-12">
				<div className="row">
					<div className="col-md-6 col-xs-12">
						<div className='col-xs-4'>
							<div className='input-wrap'>
								<label>Lada</label>
								<span className='clearfix input-active'>
									<Field name="lada_movil" component={renderField} type="text" max="4" validate={telefono('lada_movil')} />
								</span>
							</div>
						</div>
						<div className='col-xs-8'>
							<div className='input-wrap'>
								<label>Teléfono</label>
								<span className='clearfix input-active'>
									<Field name="telefono_movil" component={renderField} type="text" max="8" validate={telefono('telefono_movil')} />
								</span>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-xs-12">
						<div className='col-xs-4'>
							<div className='input-wrap'>
								<label>Lada</label>
								<span className='clearfix'>
									<Field name="lada_fijo" component={renderField} type="text" max="4" cerrar={this.cerrar.bind(this,'lada_fijo')} onFocus={this.focus.bind(this)} validate={telefono('lada_fijo')} />
								</span>
							</div>
						</div>
						<div className='col-xs-8'>
							<div className='input-wrap'>
								<label>Teléfono</label>
								<span className='clearfix'>
									<Field name="telefono_fijo" component={renderField} type="text" max="8" cerrar={this.cerrar.bind(this,'telefono_fijo')} onFocus={this.focus.bind(this)} validate={telefono('telefono_fijo')} />
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
    		<div className="col-xs-12">
				<h5><i><img src={ require("../img/icon-password.png") } /></i>Establecer contraseña
					<span className="orange-tooltip">
						<button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-contrasena">
							<img src={ require("../img/icon_information.png") } />
						</button>
					</span>
				</h5>
			</div>
			<div className="col-xs-12">
				<div className="row">
					<div className="col-md-6 col-xs-12">
						<Field name="password" label="Contraseña" component={campo} max="25" type="password" props={{param:this.state.showPass, fnToggle: this.toggle.bind(this, "showPass"),clase:'pass'}}/>
					</div>
					<div className="col-md-6 col-xs-12">
						<Field name="confpassword" label="Confirmar contraseña" max="25" component={campo} type="password" props={{param:this.state.showConfPass, fnToggle: this.toggle.bind(this, "showConfPass"),clase:'confpass'}}/>
					</div>
				</div>
			</div>
			<div className="col-xs-12">
				<h5>
					<i><img src={ require("../img/icon-question.png") } /></i>Preguntas Secretas
					<span className="orange-tooltip">
						<button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-preguntas">
							<img src={ require("../img/icon_information.png") } />
						</button>
					</span>
				</h5>
			</div>

			<div className="col-xs-12 col-md-6">
				<div className="row mt-25">
					<div className="col-xs-12">
						<Field name="pregunta1" component={renderSelectField} label="Pregunta 1">
						<option value="0">Selecciona una pregunta</option>
							{ this.props.preguntas1.map((item,i) =>
                                <option key={i} value={item.id}>{item.descripcion}</option>
                            )}
						</Field>
					</div>
					<div className="col-xs-12 mt-34">
						<Field name="respuesta1" label="Respuesta" component={campo} type="password" validate={espacios('respuesta1')} props={{param:this.state.showResp1, fnToggle: this.toggle.bind(this, "showResp1")}}/>
					</div>
				</div>
			</div>

			<div className="col-xs-12 col-md-6">
				<div className="row mt-25">
					<div className="col-xs-12">
						<Field name="pregunta2" component={renderSelectField} label="Pregunta 2">
						<option value="0">Selecciona una pregunta</option>
							{ this.props.preguntas2.map((item,i) =>
                                <option key={i} value={item.id}>{item.descripcion}</option>
                            )}
						</Field>
					</div>
					<div className="col-xs-12 mt-34">
						<Field name="respuesta2" label="Respuesta" component={campo} type="password" validate={espacios('respuesta2')} props={{param:this.state.showResp2, fnToggle: this.toggle.bind(this, "showResp2")}}/>
					</div>
				</div>
			</div>

        </div>
        </div>
			<button className="orange-rectangle" type="submit">Siguiente</button>

    			<div className='modal fade' id='modal-contrasena' tabIndex='-1' role='dialog' aria-labelledby='modal-contrasenaLabel'>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title' id='modal-contrasenaLabel'>Para tu nueva contraseña contempla que:</h4>
							</div>
							<div className='modal-body'>
								<ol>
									<li>Debe ser de al menos 8 posiciones, incluyendo caracteres alfanuméricos.</li>
									<li>No debe contener caracteres especiales.</li>
									<li>No debe contener la palabra GNP.</li>
									<li>No debe contener más de dos caracteres iguales de forma consecutiva (p.e. 222, eee).</li>
									<li>No debe contener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc).</li>
                    <li>Debe incluir al menos una letra mayúscula, una letra minúscula y un número.</li>
								</ol>
							</div>
							<div className='modal-footer'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				<div className='modal fade' id='modal-preguntas' tabIndex='-1' role='dialog' aria-labelledby='modal-preguntasLabel'>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title' id='modal-preguntasLabel'>Importante</h4>
							</div>
							<div className='modal-body text-center'>
								<p> Las preguntas secretas ayudarán a desbloquear tu contraseña en caso de olvidarla.</p>
							</div>
							<div className='modal-footer'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				<div className='modal fade' id='modal-telefonos' tabIndex='-1' role='dialog' aria-labelledby='modal-telefonosLabel'>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title' id='modal-preguntasLabel'>Importante</h4>
							</div>
							<div className='modal-body text-center'>
								<p> Es importante que nos proporciones el teléfono celular ya que a este número te contactaremos en caso de que olvides tu contraseña o requieras asistencia.</p>
							</div>
							<div className='modal-footer'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
        </form>;
    }
}

SeguridadForm = reduxForm({
	form: 'datosSeguridad',
	validate
})(SeguridadForm);

export default connect(mapState, mapDispatch)(SeguridadForm);



// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/seguridad.frm.js